<template>
  <nav
    :class="`navbar navbar-${getColorMode.background} bg-${getColorMode.background} text-${getColorMode.text} d-flex flex-wrap align-items-center row`"
  >
    <div class="container-fluid">
      <div class="ms-auto d-flex btns-header">
        <button
          class="me-3 rounded-circle text-warning btn-outline-faded btn-color-mode"
          type="button"
          @click="changeColorMode"
          aria-label="Toggle theme"
        >
          <span v-if="this.theme == 'darkMode'">
            <font-awesome-icon :icon="['fas', 'sun-bright']" />
          </span>
          <span v-else>
            <font-awesome-icon :icon="['fas', 'moon']" />
          </span>
        </button>
        <div class="dropdown d-inline-block dropdown-user">
          <a
            href="javascript:;"
            class="d-flex align-items-center text-decoration-none dropdown-toggle"
            id="dropdownUser1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img
              :src="userImage"
              alt=""
              width="45"
              height="45"
              class="rounded-circle me-2"
            />
            <strong class="header-title">{{ user.name }}</strong>
          </a>
          <ul
            class="dropdown-menu dropdown-menu-end text-small shadow header-title"
            aria-labelledby="dropdownUser1"
          >
            <li>
              <a class="dropdown-item" href="javascript:;" @click="logout"
                >Cerrar sesión</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      theme: "",
      userImage: require("@/assets/images/general/user.png"),
    };
  },
  methods: {
    logout() {
      this.$auth.logout({
        redirect: "/login",
        success: function (msg) {
          console.error("LOGIN:", msg);
        },
      });
    },
    ...mapMutations("general", ["toggleShowSideBar"]),
    ...mapMutations("general", ["toggleColorMode"]),
    toggleSidebar() {
      this.toggleShowSideBar();
    },
    changeColorMode() {
      this.theme = this.theme == "darkMode" ? "" : "darkMode";
      document.documentElement.setAttribute("data-theme", this.theme);
      localStorage.setItem("theme", this.theme);
      this.toggleColorMode(this.theme);
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    user() {
      return this.$auth.user();
    },
  },
};
</script>
